import { BaseDto } from '../base.dto';
import { MerchantDto } from '../merchant.dto';

export class GiftCardStockDto extends BaseDto {
  merchant: MerchantDto;
  weekNo: number;
  year: number;
  closed: boolean;
  verifiedDate?: Date;
  cardCountAdded: number;
  cardCountAvailable: number;
  cardCount: number;
  cardCountSold: number;
  cardCountMissing: number;
}
